import React from 'react';
import './OurValues.css';

//images
import Integrity from '../AboutImages/integrity.png';
import Compassion from '../AboutImages/compassion.png';
import Innovation from '../AboutImages/innovation.png';
import Transparency from '../AboutImages/transparency.png';
import Community from '../AboutImages/community.png';
import Excellence from '../AboutImages/excellence.png';

function OurValues(){
    return(
        <>
            <div className='ourvalues-container'>
                <div className='ourvalues-inner'>
                    <h2 className='ourvalues-header'>our values</h2>
                    <div className="ourvalues-grid-container">
                        <div className="ourvalues-grid-item">
                            <div className="ourvalues-grid-item-img">
                                <img src={Integrity} alt='integrity'/>
                            </div>
                            <div className="ourvalues-grid-item-con">
                                <h2>integrity</h2>
                                <p>
                                    Ensuring clear communication and ethical decision-making, especially in accordance with regulations in different regions.
                                </p>
                            </div>
                        </div>
                        <div className="ourvalues-grid-item">
                            <div className="ourvalues-grid-item-img">
                                <img src={Compassion} alt='compassion'/>
                            </div>
                            <div className="ourvalues-grid-item-con">
                                <h2>Compassion</h2>
                                <p>
                                    Offering personalized patient support to ensure that healthcare is both accessible and reassuring.
                                </p>
                            </div>
                        </div>
                        <div className="ourvalues-grid-item">
                                <div className="ourvalues-grid-item-img">
                                    <img src={Innovation} alt='Innovation'/>
                                </div>
                                <div className="ourvalues-grid-item-con">
                                    <h2>Innovation</h2>
                                    <p>
                                    Investing in R&D to develop new, affordable medications that address unmet needs in global healthcare.
                                    </p>
                                </div>
                        </div>
                        <div className="ourvalues-grid-item">
                            <div className="ourvalues-grid-item-img">
                                <img src={Transparency} alt='Transparency'/>
                            </div>
                            <div className="ourvalues-grid-item-con">
                                <h2>Transparency</h2>
                                <p>
                                Partnering with local health organizations to provide resources and awareness programs for better community health outcomes.
                                </p>
                            </div></div>
                        <div className="ourvalues-grid-item">
                            <div className="ourvalues-grid-item-img">
                                <img src={Community} alt='Community'/>
                            </div>
                            <div className="ourvalues-grid-item-con">
                                <h2>Community</h2>
                                <p>
                                Publishing comprehensive reports on product quality and compliance to maintain clear, honest communication with customers.
                                </p>
                            </div>
                        </div>
                        <div className="ourvalues-grid-item">
                            <div className="ourvalues-grid-item-img">
                                <img src={Excellence} alt='Excellence'/>
                            </div>
                            <div className="ourvalues-grid-item-con">
                                <h2>Excellence</h2>
                                <p>
                                Implementing rigorous quality control measures across all stages of production to ensure the reliability and safety of our medicines.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* blur box */}
                <div className='ourvalues-blurbox1'></div>
            </div>
        </>
    );
}

export default OurValues;